import { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

import { ExpandedProps } from "./interfaces";
import { Container, Expanded, Expander, IconButton } from "./styles";

const ExpandableItem = ({
  expanderContainer,
  expandedContainer,
  expanded,
  notifyControlledExpand,
  expanderBackgroundColor,
  expandedBackgroundColor,
  useSimpleView = false,
}: ExpandedProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
    notifyControlledExpand && notifyControlledExpand();
  };

  useEffect(() => {
    expanded ? setIsExpanded(expanded) : setIsExpanded(false);
  }, [expanded]);

  return (
    <Container>
      <Expander
        isExpanded={isExpanded || useSimpleView}
        expanderBackgroundColor={expanderBackgroundColor}
      >
        {!useSimpleView && (
          <IconButton
            isExpanded={isExpanded}
            onClick={toggleExpand}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </IconButton>
        )}
        {expanderContainer(isExpanded)}
      </Expander>
      <Expanded
        isExpanded={isExpanded}
        expandedBackgroundColor={expandedBackgroundColor}
      >
        {expandedContainer}
      </Expanded>
    </Container>
  );
};

export default ExpandableItem;
